const form = () => {
    const inputs = document.querySelectorAll('.form-input');

    inputs.forEach(input => {
      const group = input.closest('.form-group');

      // Dodaj/usuń klasę is-filled na zmianę wartości
      const updateState = () => {
        if (input.value.trim() !== '') {
          group.classList.add('is-filled');
        } else {
          group.classList.remove('is-filled');
        }
      };

      // Focus
      input.addEventListener('focus', () => {
        group.classList.add('is-focused');
      });

      // Blur
      input.addEventListener('blur', () => {
        group.classList.remove('is-focused');
        updateState();
      });

      // Inicjalizacja (np. po autouzupełnieniu)
      updateState();
    });
}

export default form;